@if (type != 3 || !type) {
  <div [className]="collapse == true ? 'input-wrapper collapsed-side-form' : 'input-wrapper'">
    <div class="icon-collapse-condense" (click)="toggleCollapse()">
      <span
      class="tooltip-text fileupload-colapse">{{translationsService.translate('galis_js_file_upload_colapse')}}</span>
    </div>
    <div class="expand" (click)="toggleCollapse()">
      <div class="expand-icon"></div>
      <span class="tooltip-text fileupload-expand">{{translationsService.translate('galis_js_file_upload_expand')}}</span>
    </div>
    <div class="side-info-table">
      <!--div class="search-loader" *ngIf="showLoader">
      <img src="/assets/css/images/platform/loader.gif" />
    </div-->
    <sem-loader [showLoader]="showLoader"></sem-loader>
    <div class="side-wrapper edit-form-title-wrapper">
      <p class="input-form-title">{{translationsService.translate(title)}}</p>
    </div>
    <div [className]="(files.length == 0 ? 'img-options disabled' : 'img-options') + (isUploadLocked ? ' upload-locked' : '')">
      @if (type == 1 && (selectedFile != null && dfms?.isFormReadOnly == false)) {
        <div class="setdefault-img" (click)="setAsDefault()"
          >
          <div class="set-as-default-empty"
            [ngClass]="{'set-as-default-empty': selectedFile.FileOrder > 1,'set-as-default-full': selectedFile.FileOrder == 1}">
          </div>
          <span
          class="tooltip-text fileupload-set-as-default">{{translationsService.translate('galis_js_file_setasdefault')}}</span>
        </div>
      }
      <div>
        <div class="search" (click)="openFileExplorer()">
          <span
          class="tooltip-text fileupload-search">{{translationsService.translate('galis_js_file_upload_search')}}</span>
        </div>
      </div>
      @if (selectedFile!=null && selectedFile.ReadOnly == false && dfms?.isFormReadOnly == false) {
        <div>
          <div class="editor-btn" (click)="openFileEditor()">
            <span
            class="tooltip-text fileupload-editor">{{translationsService.translate('galis_js_file_upload_search')}}</span>
          </div>
        </div>
      }
      @if (selectedFile != null && selectedFile.Id > 0) {
        <div class="download"
          (click)="download()">
          <span
          class="tooltip-text fileupload-download">{{translationsService.translate('galis_js_file_upload_download')}}</span>
        </div>
      }
      @if (selectedFile!=null && selectedFile.ReadOnly == false && dfms?.isFormReadOnly == false) {
        <div>
          <div (click)="confirm()" class="delete">
            <span
            class="tooltip-text fileupload-delete">{{translationsService.translate('galis_js_file_upload_delete')}}</span>
          </div>
        </div>
      }
      @if (dfms?.isFormReadOnly == false) {
        <div>
          <div class="add">
            <input #fileUpload id="fileUpload" type="file" multiple (change)="onFileChange($event)" title=" " />
            @if (type == 1) {
              <span
              class="tooltip-text fileupload-add">{{translationsService.translate('galis_js_file_upload_add_from_fs')}}</span>
            }
            @if (type == 2) {
              <span
              class="tooltip-text fileupload-add">{{translationsService.translate('galis_js_file_upload_add_from_fs_file')}}</span>
            }
          </div>
        </div>
      }
      @for (fa of fileDataActions; track fa) {
        @if (fa.Type == 3 && dfms?.isFormReadOnly == false && type == 1) {
          <div>
            <div [ngStyle]="{'background-image': 'url(/assets/css/images/platform/' + fa.Parameters.icon + ')'}"
            (click)="fileDataAction(fa)"></div>
          </div>
        }
      }
    </div>
    @if (toConfirm) {
      <div class="confirmation-wrapper">
        <div class="confirmation-row">
          <p>
            {{translationsService.translate('galis_js_file_upload_AreYouSureYouWantToDeleteThisRecord')}}
          </p>
          <div class="confirmation-delete" (click)="removeFile()">{{translationsService.translate('Delete')}}</div>
          <div class="confirmation-close" (click)="confirm()"></div>
        </div>
      </div>
    }
    @if (alreadyExists) {
      <div class="confirmation-wrapper">
        <div class="confirmation-row">
          <p>
            {{this.translationsService.translate('FileAlreadyExists')}}
          </p>
          <div class="confirmation-close" (click)="closeExists()"></div>
        </div>
      </div>
    }
    <div class="upload images">
      <div #dropArea id="dragndrop"
        [className]="(files.length == 0 ? 'div1 upload-window afu-dragndrop-box upload-img' : 'div1 upload-window afu-dragndrop-box') + (imageFit === 'contain' && files.length > 0 ? ' wg-img-contain' : '')"
        [ngStyle]="{'background-image': 'url(' + imgPath + ')','display':ddAreaDisplay}"
        [class.droparea-hovered]="dropareaActive"
        [class.upload-locked-empty]="isUploadLocked && files.length == 0">
        @if (files.length == 0 && !dropareaActive && !isUploadLocked) {
          <div class="icon"></div>
        }
        @if (files.length == 0 && !dropareaActive && !isUploadLocked) {
          <p>{{translationsService.translate(dropText)}}</p>
        }
        <!-- Remove the SELECTED image directly: with a single file the thumbnail strip
             (files.length > 1) never renders, so this was the only image you could not
             delete. Same confirmation flow as the thumbnails; gated by the readonly
             lock AND the server-supplied DeleteRight. -->
        @if (files.length > 0 && type != 2 && selectedFile && !isUploadLocked && fileDataRight.DeleteRight == true) {
          <span class="img-main-remove" [title]="translationsService.translate('galis_js_file_upload_delete')"
                (click)="confirm(); $event.stopPropagation()">
            <svg width="12" height="12" viewBox="0 0 10 10" fill="none">
              <path d="M8 2L2 8M2 2l6 6" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/>
            </svg>
          </span>
        }
      </div>
      @if (files.length > 0 && type != 2 && selectedFile) {
        <div class="img-info-bar">
          <span class="img-selected-title">{{ selectedFile.Name }}</span>
          <span class="img-selected-counter">{{ currentImageIndex }} / {{ files.length }}</span>
        </div>
      }
      <!--<div *ngIf="type != 2" class="main-img" style="background-image:url(https://placeimg.com/640/480/any)"></div>-->
      @if (files.length > 1 && type != 2) {
        <div class="img-list">
          @if (files.length > 5) {
            <div class="left" (click)="slide('left')"></div>
          }
          <div class="img-wrapper">
            @for (img of shownFiles; track img) {
              <div [makeDraggable]="img" makeDroppable (dropped)="onDrop(img,$event)"
                (click)="fileClicked(img)" class="img-preview"
                [class.img-preview--active]="img.path === imgPath"
                [ngStyle]="{'background-image': 'url(' + img.path + ')'}">
                @if (dfms?.isFormReadOnly == false) {
                  <span class="img-preview__remove" (click)="fileClicked(img); confirm(); $event.stopPropagation()">
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path d="M8 2L2 8M2 2l6 6" stroke="#fff" stroke-width="1.4" stroke-linecap="round"/>
                    </svg>
                  </span>
                }
              </div>
            }
          </div>
          @if (files.length > 5) {
            <div class="right" (click)="slide('right')"></div>
          }
        </div>
      }
      @if (shownFiles.length > 0 && type == 2) {
        <table class="files linked-files-comp">
          <tr>
            <th>{{translationsService.translations.File}}</th>
            <th>{{translationsService.translations.Type}}</th>
            <th>{{translationsService.translations.Size}}</th>
            @if (dfms?.isFormReadOnly == false) {
              <th class="wg-del-th"></th>
            }
          </tr>
          @for (file of shownFiles; track file) {
            <tr (click)="fileClicked(file)"
              [className]="(selectedFile.Name == file.name && showSelected) ? 'selected-row' : ''">
              <td>
                <div class="icon {{file.extension.toLowerCase()}}">
                  <div></div>
                  <p class="p-file-name">{{file.feName}}</p>
                </div>
              </td>
              <td>{{file.extension}}</td>
              <td>{{file.size}}</td>
              @if (dfms?.isFormReadOnly == false) {
                <td class="wg-del-cell">
                  <button class="wg-del-btn" (click)="fileClicked(file); removeFile(true); $event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                    </svg>
                  </button>
                </td>
              }
            </tr>
          }
        </table>
      }
      <!--div class="up-controls file-upload-footer">
      <p>{{translationsService.translations.Or}}</p>
      <a *ngIf="!protocolName" (click)="openFileDialog()">{{translationsService.translations.SelectFiles}}</a>
      <a *ngIf="protocolName" (click)="runProtocol()">{{translationsService.translations.SelectFiles}}</a>
    </div-->
  </div>
  <!--<div *ngIf="selectedFile" style="display:none !important;">
  <div class="file-fields">
    <p>Title: </p>
    <input [ngModel]="selectedFile?.Title" (ngModelChange)="selectedFile ? selectedFile.Title = $event : null" type="text" />
  </div>
  <div class="file-fields">
    <p>Description: </p>
    <input [ngModel]="selectedFile?.Description" (ngModelChange)="selectedFile ? selectedFile.Description = $event : null" type="text" />
  </div>
  <div class="file-fields" *ngIf="categoryEditable">
    <p>Category: </p>
    <input [ngModel]="fcategory" (ngModelChange)="fcategory = $event" type="text" />
  </div>
</div>-->
</div>
</div>
}

@if (type == 3) {
  <div class="file-sections">
    @if (enableProXSign) {
      @if (signInstructions) {
        <div class="instr-wrapper">
          <div class="instr">
            <p class="banner-text">{{signInstructions}}</p>
          </div>
        </div>
      }
      @if (!error) {
        @if (versionText && versionText.length > 0 && !certLoad) {
          <div class="pxs-ready">
            <svg class="pxs-ready-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              <path d="M9 12l2 2 4-4"/>
            </svg>
            <span class="pxs-ready-text">{{versionText}} ({{versionNumber}})</span>
            <span class="pxs-ready-spacer"></span>
            @if (selectedSubject && selectedSubject.length > 0) {
              <span class="pxs-ready-cert">{{selectedSubject}}</span>
              <span class="pxs-ready-sep"></span>
            }
            <span class="pxs-ready-link" (click)="selectCert()">Spremeni certifikat</span>
          </div>
        }
      }
    @if (error && !certLoad) {
      <div class="pxs-alert">
        <div class="pxs-alert-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            <path d="M12 8v4"/><circle cx="12" cy="16" r="0.5" fill="currentColor"/>
          </svg>
        </div>
        <div class="pxs-alert-content">
          <p class="pxs-alert-title">Podpisna komponenta ni dosegljiva</p>
          <p class="pxs-alert-text">Namizna aplikacija SETCCE proXSign ni dosegljiva na vaši napravi. Prosimo, preverite da je nameščena in aktivna.</p>
          <p class="pxs-alert-text">Vloge ni mogoče oddati brez aktivne podpisne komponente in veljavnega digitalnega potrdila.</p>
          <a class="pxs-alert-link" target="_blank" href="https://www.si-trust.gov.si/sl/podpora-uporabnikom/podpisovanje-s-komponento-proxsign">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
            Namestite podpisno komponento
          </a>
        </div>
      </div>
    }
    @if (certLoad) {
      <div class="com-loader-wrapper">
        <div class="loader-wrapper com-loader-w">
          <span class="loader"></span>
        </div>
        <div>
          <p>Poteka povezovanje podpisne komponente na vaši napravi ...</p>
        </div>
      </div>
    }
  }
  @if (!boundedProperty || boundedProperty.length == 0) {
    @if (reviewEnabled && sectionState) {
      <div class="file-section-state" [class.file-section-state-missing]="sectionState.State == 'Missing'"
        [class.file-section-state-pending]="sectionState.State == 'Pending'"
        [class.file-section-state-rejected]="sectionState.State == 'Rejected'"
        [class.file-section-state-confirmed]="sectionState.State == 'Confirmed'">
        {{ sectionStateText() }}
      </div>
    }
    @if (fileDataRight.WriteRight && !dfms?.isFormReadOnly && !isReadOnly && !checkForDisabled(null) && !enableProXSign && !uploadHiddenByReview()) {
      <div class="file-sections-dropzone" [class.file-sections-dropzone-active]="fileSectionsDragActive">
        <div class="dropzone-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="17 8 12 3 7 8"/>
            <line x1="12" y1="3" x2="12" y2="15"/>
          </svg>
        </div>
        <p class="dropzone-text">Povlecite datoteke sem</p>
        <p class="dropzone-subtext">ali</p>
        <div class="add-file-section">
          <p>{{translationsService.translate('galis_js_add_file')}}</p>
          <input class="file-section-add" #fileUpload id="fileUpload" type="file" multiple (change)="onFileChange($event)"
            title=" " />
        </div>
      </div>
      }
      @if (getCurrentFiles(); as shownFiles) {
        @if (shownFiles.length > 0 && !isReadOnly && !checkForDisabled(null)) {
          <p>
            {{ translationsService.translate('galis_js_added_files') }}
          </p>
        }
        @for (file of shownFiles; track trackByFileId($index, file)) {
          <div class="section-file" [class.section-file-review]="reviewEnabled" (click)="handleFileClick(file)">
            <p>{{ file.name }}</p>
            @if (reviewEnabled && isSavedFile(file)) {
              <span class="file-review-badge" [class.file-review-pending]="reviewStatus(file) == 0"
                [class.file-review-confirmed]="reviewStatus(file) == 1" [class.file-review-rejected]="reviewStatus(file) == 2"
                [title]="reviewComment(file)">{{ reviewBadgeText(file) }}</span>
              @if (reviewComment(file)) {
                <span class="file-review-comment">{{ reviewComment(file) }}</span>
              }
            }
            @if (!dfms?.isFormReadOnly && !isReadOnly && (file.id === 0 || file.id || deleteEnabled) && !checkForDisabled(null) && !(lockSavedFiles && isSavedFile(file))) {
              <img
                (click)="handleFileClick(file); removeFile()"
                src="../../../../assets/css/images/platform/remove-file@3x.png" />
            }
            @if (!previewDisabled) {
              <img (click)="handleFileClick(file); openFileInExplorer(file)"
                src="../../../../assets/css/images/platform/s-icon-open@3x.png" />
            }
            <img (click)="handleFileClick(file); download()" src="../../../../assets/css/images/platform/download_o.png" />
            @if (downloadInProgress) {
              <div class="dd-loader"></div>
            }
            <!-- Optional ProXSign button -->
            @if (!isInNgFor && enableProXSign && proXSignAvailable) {
              <button class="app-form-btn" type="button"
                (click)="signDocument()">
                Podpiši
              </button>
            }
            <!-- Per-file review (group-gated in the UI, enforced by the backend action) -->
            @if (canReview() && isSavedFile(file)) {
              @if (reviewStatus(file) != 1) {
                <button class="file-review-btn file-review-btn-confirm" type="button" title="Potrdi datoteko"
                  (click)="reviewFile(file, true, $event)">
                  <svg class="file-review-btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                  <span>Potrdi</span>
                </button>
              }
              @if (reviewStatus(file) != 2 && reviewRejectAction) {
                <button class="file-review-btn file-review-btn-reject" type="button" title="Zavrni datoteko"
                  (click)="reviewFile(file, false, $event)">
                  <svg class="file-review-btn-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                  </svg>
                  <span>Zavrni</span>
                </button>
              }
            }
          </div>
        }
        @if (shownFiles.length === 0 && !isReadOnly && !proXSignAvailable && !checkForDisabled(null)) {
          <div class="section-file no-file">
            <p>Ni pripetih datotek.</p>
          </div>
        }
      }
      @if (proXSignAvailable && proXSignFileDownloading) {
        <div class="section-file no-file px-no-file">
          <p>Prosimo, počakajte ...</p>
          <div class="dd-loader"></div>
        </div>
      }
    }
    @if (boundedProperty && boundedProperty.length > 0) {
      @if (getBoundedProp(); as boundedProps) {
        @for (obj of boundedProps; track obj; let i = $index) {
          @if (evaluateBoundedCondition(obj)) {
            <p class="fd-title">{{evaluateBoundedTitle(obj)}}</p>
            @if (fileDataRight.WriteRight && !dfms?.isFormReadOnly && !isReadOnly && !checkForDisabled(null)) {
              <div class="add-file-section">
                <p>{{translationsService.translate('galis_js_add_file')}}</p>
                <input class="file-section-add" type="file" (change)="onFileChange($event, obj)" title=" " />
              </div>
            }
            @if (getShownFiles(obj); as shownFiles) {
              @if (shownFiles.length > 0 && !isReadOnly && !checkForDisabled(null)) {
                <p>
                  {{ translationsService.translate('galis_js_added_files') }}
                </p>
              }
              @for (file of shownFiles; track trackByFileId($index, file)) {
                <div class="section-file">
                  <p (click)="fileClickedInline(file)">{{ file.name }}</p>
                  @if (!dfms?.isFormReadOnly && !isReadOnly && (file.id === 0 || file.id || deleteEnabled)) {
                    <img
                      (click)="fileClickedInline(file); removeFile()"
                      src="../../../../assets/css/images/platform/remove-file@3x.png" />
                  }
                  @if (!previewDisabled) {
                    <img (click)="fileClickedInline(file); openFileInExplorer(file)"
                      src="../../../../assets/css/images/platform/s-icon-open@3x.png" />
                  }
                  <img (click)="fileClickedInline(file); download();"
                    src="../../../../assets/css/images/platform/download_o.png" />
                    @if (downloadInProgress) {
                      <div class="dd-loader"></div>
                    }
                  </div>
                }
                @if (shownFiles.length === 0 && !isReadOnly && !proXSignAvailable && !checkForDisabled(null)) {
                  <div class="section-file no-file">
                    <p>Ni pripetih datotek.</p>
                  </div>
                }
              }
            }
          }
        }
        <!-- BACKEND COMPATIBILITY-->
        @for (file of getShownFilesEmpty(); track file) {
          <div class="section-file" (click)="fileClicked(file)">
            <!--<p (click)="fileClickedInline(file);download();">{{file.name}}</p>-->
            <p (click)="fileClickedInline(file);">{{file.name}}</p>
            @if (!dfms?.isFormReadOnly && !isReadOnly && (deleteEnabled || file.id === 0 || file.id !== undefined)) {
              <img (click)="fileClickedInline(file);removeFile()"
                src="../../../../assets/css/images/platform/remove-file@3x.png" />
            }
            @if (!previewDisabled) {
              <img (click)="fileClickedInline(file);openFileInExplorer(file);"
                src="../../../../assets/css/images/platform/s-icon-open@3x.png" />
            }
            <img (click)="fileClickedInline(file);download();" src="../../../../assets/css/images/platform/download_o.png" />
            @if (downloadInProgress) {
              <div class="dd-loader"></div>
            }
          </div>
        }
      }
    </div>
  }